import { useMemo } from 'react';

function looksLikeHtml(s: string): boolean {
  const head = s.trim().slice(0, 800).toLowerCase();
  return (
    head.startsWith('<!doctype') ||
    head.startsWith('<html') ||
    head.includes('<html') ||
    /<(p|div|table|span|br|body|head|style|meta)\b/.test(head)
  );
}

function wrapHtmlDocument(html: string): string {
  const trimmed = html.trim();
  if (/<html[\s>]/i.test(trimmed)) return trimmed;
  return `<!DOCTYPE html><html><head><meta charset="utf-8"><base target="_blank"><style>
    body{font-family:system-ui,sans-serif;font-size:14px;line-height:1.45;color:#1c2420;margin:12px;word-break:break-word;}
    img{max-width:100%;height:auto;}
    a{color:#0d5c4d;}
  </style></head><body>${trimmed}</body></html>`;
}

type Props = {
  from?: string;
  dateLabel?: string;
  bodyText?: string;
  bodyHtml?: string;
};

export function EmailBody({ from, dateLabel, bodyText, bodyHtml }: Props) {
  const html = useMemo(() => {
    if (bodyHtml && bodyHtml.trim()) return wrapHtmlDocument(bodyHtml);
    if (bodyText && looksLikeHtml(bodyText)) return wrapHtmlDocument(bodyText);
    return null;
  }, [bodyHtml, bodyText]);

  return (
    <div className="email-body">
      <div className="email-meta">
        Da: {from || '—'}
        {'\n'}
        Data: {dateLabel || '—'}
      </div>
      {html ? (
        <iframe className="mail-frame" title="Email originale" sandbox="" srcDoc={html} />
      ) : (
        <div className="mail-plain">{bodyText || '(vuoto)'}</div>
      )}
    </div>
  );
}
